import { useMutation, useQueryClient } from '@tanstack/react-query';
import { beneficiaryService } from '../../services/beneficiary.service';
import { notifyUser } from '../../util/util';

const invalidateKeys = (queryClient) => {
  const keys = [
    ['scheme-beneficiaries'],
    ['all-life'],
    ['all-pension'],
    ['all-beneficiary'],
  ];
  keys.forEach((key) => queryClient.invalidateQueries({ queryKey: key }));
};

export function useAddBeneficiary() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: beneficiaryService.addBeneficiary,
    onSuccess: (data) => {
      console.log('Add Beneficiary Success Response:', data);
      notifyUser('success', data?.message || 'Beneficiary added successfully.', 'Success');
      invalidateKeys(queryClient);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to add beneficiary.';
      notifyUser('error', message, 'Error');
    },
  });
}